module.exports = __webpack_public_path__ + "static/media/Fill 1.8a72f4db.png";